import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { api } from "@/lib/api";

export const GlobalSearch = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) { setQ(""); setRes(null); return; }
  }, [open]);

  useEffect(() => {
    if (q.length < 2) { setRes(null); return; }
    const t = setTimeout(() => api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setRes(r.data)).catch(() => setRes(null)), 250);
    return () => clearTimeout(t);
  }, [q]);

  const go = (path) => { onOpenChange(false); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput data-testid="global-search-input" placeholder="Search SKU, option, style, barcode, store…" value={q} onValueChange={setQ} />
      <CommandList data-testid="global-search-results">
        <CommandEmpty>{q.length < 2 ? "Type at least 2 characters" : "No matches"}</CommandEmpty>
        {res?.skus?.length > 0 && <CommandGroup heading="SKUs">{res.skus.map((s) => <CommandItem key={s.id} value={`sku ${s.code} ${s.barcode}`} onSelect={() => go(`/skus/${s.code}`)} data-testid={`search-sku-${s.code}`}><span className="font-mono text-xs mr-2">{s.code}</span><span className="text-slate-500 text-xs truncate">{s.name}</span></CommandItem>)}</CommandGroup>}
        {res?.options?.length > 0 && <CommandGroup heading="Options">{res.options.map((o) => <CommandItem key={o.id} value={`option ${o.code} ${o.name}`} onSelect={() => go(`/options/${o.code}`)} data-testid={`search-option-${o.code}`}><span className="font-mono text-xs mr-2">{o.code}</span><span className="text-slate-500 text-xs truncate">{o.name}</span></CommandItem>)}</CommandGroup>}
        {res?.styles?.length > 0 && <CommandGroup heading="Styles">{res.styles.map((s) => <CommandItem key={s.id} value={`style ${s.code} ${s.name}`} onSelect={() => go(`/merchandise?tab=options&style=${s.code}`)}><span className="font-mono text-xs mr-2">{s.code}</span><span className="text-slate-500 text-xs truncate">{s.name}</span></CommandItem>)}</CommandGroup>}
        {res?.stores?.length > 0 && <CommandGroup heading="Locations">{res.stores.map((s) => <CommandItem key={s.id} value={`store ${s.code} ${s.name}`} onSelect={() => go(`/inventory/overview?location=${s.id}`)}><span className="font-mono text-xs mr-2">{s.code}</span><span className="text-slate-500 text-xs">{s.name}</span></CommandItem>)}</CommandGroup>}
      </CommandList>
    </CommandDialog>
  );
};
